(function (Drupal, once) {

  // Give your behavior a descriptive name
  Drupal.behaviors.transactionHistoryToggle = {
    attach: function attach(context) {
      return;
      // Use 'once' to ensure the event listener is attached only once per element.
      // The first argument to once() is a unique ID for this 'once' operation,
      // the second is the CSS selector for the element(s) to process,
      // and the third is the 'context' provided by Drupal's attach function.
      once('fiservTransactionTriggerEvent', '#fiserv-transaction-trigger', context).forEach(function (toggleButton) {
        // Find the transaction list container within the current context.
        // IMPORTANT: Ensure '.transaction-list-container' (from our CSS) is the correct
        // class for the element that has the max-height and transition styles.
        // Your code used '.transaction-list', which might be an inner element.
        // Let's assume you want to toggle the outer container as per our previous CSS.
        const transactionListContainer = context.querySelector('.transaction-list-container');

        // Ensure the list container exists before attaching the listener
        if (transactionListContainer) {
          toggleButton.addEventListener('click', function (event) {
            window.
            event.preventDefault(); // Crucial for <a> tags to prevent default browser behavior (e.g., jumping to top)

            // Toggle the 'is-expanded' class on the TRANSACTION LIST CONTAINER
            transactionListContainer.classList.toggle('is-expanded');

            // Update the BUTTON's text based on the list container's new state
            // 'this' inside the event listener refers to the 'toggleButton' element itself
            if (transactionListContainer.classList.contains('is-expanded')) {
              this.textContent = 'Hide Transaction History';
            } else {
              this.textContent = 'View Transaction History';
            }
          });
        }
      });
    }
  };
})(Drupal, once);
